var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _defs, _g19, _defs2, _g20, _g21, _g22, _g23, _g24, _defs3, _g25, _defs4, _g26, _defs5, _g27, _defs6, _g28, _g29, _defs7, _g30, _defs8, _defs9, _g31, _g32, _defs10, _g33, _defs11, _g34, _g35, _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12, _animate13, _animate14, _animate15, _animate16, _animate17, _animate18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportingMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m6g5hnlc22252193",
    viewBox: "0 0 420 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlc22252193_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlc22252193",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlf05294520_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlf05294520_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlf05294520",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlf05294520_fill_path",
    d: "M0.01,0h419.98c0.00552,0 0.01,0.00448 0.01,0.01v249.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-419.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-249.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fillRule: "nonzero",
    fill: "rgb(255, 218, 187)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m6g5hnlf05294520_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlg31919054_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-126.0778,-201.1097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlg31919054",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlh07064664_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,45.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlh07064664",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlh34155443_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.459,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlh34155443",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlh34155443_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlh34155443_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnlh34155443ps0)",
    mask: "url(#m6g5hnlh34155443_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlj57128816_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,663.7341,311.2439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlj57128816",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlj57128816_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlj57128816_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnlj57128816ps0)",
    mask: "url(#m6g5hnlj57128816_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlk24330168_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,669.134,251.3645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlk24330168",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlk24330168_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlk24330168_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnlk24330168ps0)",
    mask: "url(#m6g5hnlk24330168_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlm18137040_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,67.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlm18137040",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlm18137040_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlm18137040_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnlm18137040ps0)",
    mask: "url(#m6g5hnlm18137040_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnln10579293_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,663.134,367.4938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnln10579293",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnln10579293_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnln10579293_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnln10579293ps0)",
    mask: "url(#m6g5hnln10579293_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlo92483125_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,414.0508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlo92483125",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlo92483125_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlo92483125_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnlo92483125ps0)",
    mask: "url(#m6g5hnlo92483125_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlp68104355_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,92.677,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlp68104355",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlp43733029_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.6008,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlp43733029",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlp43733029_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlp43733029_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnlp43733029ps0)",
    mask: "url(#m6g5hnlp43733029_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlq98675779_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.6008,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlq98675779",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlq98675779_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlq98675779_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnlq98675779ps0)",
    mask: "url(#m6g5hnlq98675779_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlr44310158_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlr44310158",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlr44310158_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlr44310158_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnlr44310158ps0)",
    mask: "url(#m6g5hnlr44310158_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnls89002682_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.6008,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnls89002682",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnls89002682_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnls89002682_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnls89002682ps0)",
    mask: "url(#m6g5hnls89002682_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlt93516540_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,349.6008,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlt93516540",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlt93516540_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlt93516540_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnlt93516540ps0)",
    mask: "url(#m6g5hnlt93516540_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlu93782052_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,106.404,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlu93782052",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlu93782052_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlu93782052_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnlu93782052ps0)",
    mask: "url(#m6g5hnlu93782052_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlu76798969_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,525.1618,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlu76798969",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlu76798969_stroke_path",
    d: "M0,0v571.57257",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlu76798969_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,570.57257)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -572.1726,
    width: 1.7999999999999998,
    height: 1716.5178,
    fill: "url(#m6g5hnlu76798969ps0)",
    mask: "url(#m6g5hnlu76798969_gradient_mask)"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlw83022587_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017453292520723307,0.9999999999984769,-0.9999999999984769,0.0000017453292520723307,522.6563,36.5925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlw83022587",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlw83022587_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlw83022587_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6g5hnlw83022587ps0)",
    mask: "url(#m6g5hnlw83022587_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlw65761525_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,154.1997,126.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlw65761525",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlw65761525_stroke_path",
    d: "M89.9078,80.7001c0,0 0,-61.5799 0,-63.9c0,-2.3201 -0.3915,-4.2857 -1.2785,-6.4294c-0.887,-2.1437 -2.0008,-3.8085 -3.6422,-5.4499c-1.6414,-1.6414 -3.3062,-2.7552 -5.4499,-3.6422c-2.1437,-0.887 -4.1093,-1.2785 -6.4294,-1.2785c-2.3201,0 -73.1078,0 -73.1078,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnlw65761525_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -91.1078,
    y: -81.90010000000001,
    width: 273.3234,
    height: 245.70030000000003,
    fill: "url(#m6g5hnlw65761525ps0)",
    mask: "url(#m6g5hnlw65761525_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g8kjoe96977954_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.123233995736766e-17,1,0.9999,-6.122621672337193e-17,154.1997,127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g8kjoe96977954",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g8kjoe96977954_stroke_path",
    d: "M84.3856,80.8003c0,0 0,-61.6802 0,-64.0003c0,-2.3201 -0.3915,-4.2857 -1.2785,-6.4294c-0.887,-2.1437 -2.0008,-3.8085 -3.6422,-5.4499c-1.6414,-1.6414 -3.3062,-2.7552 -5.4499,-3.6422c-2.1437,-0.887 -4.1093,-1.2785 -6.4294,-1.2785c-2.3201,0 -67.5856,0 -67.5856,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g8kjoe96977954_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -85.5856,
    y: -82.0003,
    width: 256.7568,
    height: 246.0009,
    fill: "url(#m6g8kjoe96977954ps0)",
    mask: "url(#m6g8kjoe96977954_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g8kjof78249285_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,154.1997,127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g8kjof78249285",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g8kjof78249285_stroke_path",
    d: "M31.71918,80.80029l0,-80.80029l-31.71918,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g8kjof78249285_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -32.919200000000004,
    y: -82.0003,
    width: 98.75760000000001,
    height: 246.0009,
    fill: "url(#m6g8kjof78249285ps0)",
    mask: "url(#m6g8kjof78249285_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g8kjog57953543_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.123233995736766e-17,1,0.9999,-6.122621672337193e-17,154.1868,126.4761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g8kjog57953543",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g8kjog57953543_stroke_path",
    d: "M28.52392,80.66137l0,-80.66137l-28.52408,0.00008",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g8kjog57953543_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -29.7239,
    y: -81.8614,
    width: 89.1717,
    height: 245.5842,
    fill: "url(#m6g8kjog57953543ps0)",
    mask: "url(#m6g8kjog57953543_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlx43719869_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,229.7998,149.6976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlx43719869",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlx43719869_fill_path",
    d: "M10.8,5.4436c0,3.0065 -2.4176,5.4436 -5.4,5.4436c-2.9824,0 -5.4,-2.4371 -5.4,-5.4436c0,-3.0065 2.4176,-5.4436 5.4,-5.4436c2.9824,0 5.4,2.4371 5.4,5.4436z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnly18310806_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,229.7998,90.4226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnly18310806",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnly18310806_fill_path",
    d: "M10.8,5.4436c0,3.0065 -2.4176,5.4436 -5.4,5.4436c-2.9824,0 -5.4,-2.4371 -5.4,-5.4436c0,-3.0065 2.4176,-5.4436 5.4,-5.4436c2.9824,0 5.4,2.4371 5.4,5.4436z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlz80059920_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,229.7998,31.1486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlz80059920",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlz80059920_fill_path",
    d: "M10.8,5.4436c0,3.0065 -2.4176,5.4436 -5.4,5.4436c-2.9824,0 -5.4,-2.4371 -5.4,-5.4436c0,-3.0065 2.4176,-5.4436 5.4,-5.4436c2.9824,0 5.4,2.4371 5.4,5.4436z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlz46355305_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,230.3999,205.9474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnlz46355305",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnlz46355305_fill_path",
    d: "M10.8,5.4436c0,3.0065 -2.4176,5.4436 -5.4,5.4436c-2.9824,0 -5.4,-2.4371 -5.4,-5.4436c0,-3.0065 2.4176,-5.4436 5.4,-5.4436c2.9824,0 5.4,2.4371 5.4,5.4436z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm206260455_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,22.8999,98.8907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm206260455",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm206260455_fill_path",
    d: "M26.6744,0h54.1366c14.73186,0 26.6744,11.94254 26.6744,26.6744v0c0,14.73186 -11.94254,26.6744 -26.6744,26.6744h-54.1366c-14.73186,0 -26.6744,-11.94254 -26.6744,-26.6744v0c0,-14.73186 11.94254,-26.6744 26.6744,-26.6744z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnm206260455_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm206260455_stroke_path",
    d: "M26.6744,0h54.1366c14.73186,0 26.6744,11.94254 26.6744,26.6744v0c0,14.73186 -11.94254,26.6744 -26.6744,26.6744h-54.1366c-14.73186,0 -26.6744,-11.94254 -26.6744,-26.6744v0c0,-14.73186 11.94254,-26.6744 26.6744,-26.6744z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnm206260455_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm206260455_stroke_path",
    d: "M26.6744,0h54.1366c14.73186,0 26.6744,11.94254 26.6744,26.6744v0c0,14.73186 -11.94254,26.6744 -26.6744,26.6744h-54.1366c-14.73186,0 -26.6744,-11.94254 -26.6744,-26.6744v0c0,-14.73186 11.94254,-26.6744 26.6744,-26.6744z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.783,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnm206260455_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -108.2684,
    y: -54.1318,
    width: 324.8052,
    height: 162.3954,
    fill: "url(#m6g5hnm206260455ps0)",
    mask: "url(#m6g5hnm206260455_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm278969797_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,15.661,15.8744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm278969797",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm204507659_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm204507659",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnm204507659_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm204507659_fill_path",
    d: "M0.01,0h21.58c0.00552,0 0.01,0.00448 0.01,0.01v21.58c0,0.00552 -0.00448,0.01 -0.01,0.01h-21.58c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-21.58c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnm204507659_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmi33712270_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.6,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmi33712270",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmi33712270_stroke_path",
    d: "M9,0h-7.2c-0.47739,0 -0.93523,0.18964 -1.27279,0.52721c-0.33757,0.33757 -0.52721,0.7954 -0.52721,1.27279v14.4c0,0.47739 0.18964,0.93523 0.52721,1.27279c0.33757,0.33757 0.7954,0.52721 1.27279,0.52721h10.8c0.47739,0 0.93523,-0.18964 1.27279,-0.52721c0.33757,-0.33757 0.52721,-0.7954 0.52721,-1.27279v-10.8z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmi33712270_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -16.8,
    y: -20.4,
    width: 50.400000000000006,
    height: 61.199999999999996,
    fill: "url(#m6g5hnmi33712270ps0)",
    mask: "url(#m6g5hnmi33712270_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmj78884363_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.6,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmj78884363",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmj78884363_stroke_path",
    d: "M0,0v5.4h5.4",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmj78884363_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(1,0,0,1,5.4,5.4)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -7.800000000000001,
    y: -7.800000000000001,
    width: 23.400000000000002,
    height: 23.400000000000002,
    fill: "url(#m6g5hnmj78884363ps0)",
    mask: "url(#m6g5hnmj78884363_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmk25102132_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.2,11.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmk25102132",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmk25102132_stroke_path",
    d: "M7.2,0h-7.2",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmk25102132_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(1,-2.4492935982947064e-16,2.4492935982947064e-16,1,7.2,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -9.6,
    y: -2.4,
    width: 28.799999999999997,
    height: 7.199999999999999,
    fill: "url(#m6g5hnmk25102132ps0)",
    mask: "url(#m6g5hnmk25102132_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmk71564958_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.2,15.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmk71564958",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmk71564958_stroke_path",
    d: "M7.2,0h-7.2",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmk71564958_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(1,-2.4492935982947064e-16,2.4492935982947064e-16,1,7.2,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -9.6,
    y: -2.4,
    width: 28.799999999999997,
    height: 7.199999999999999,
    fill: "url(#m6g5hnmk71564958ps0)",
    mask: "url(#m6g5hnmk71564958_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnml62860511_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.2,8.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnml62860511",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnml62860511_stroke_path",
    d: "M1.8,0h-0.9h-0.9",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnml62860511_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(1,-2.4492935982947064e-16,2.4492935982947064e-16,1,1.8,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -4.2,
    y: -2.4,
    width: 12.600000000000001,
    height: 7.199999999999999,
    fill: "url(#m6g5hnml62860511ps0)",
    mask: "url(#m6g5hnml62860511_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm584301770_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.1634,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm584301770",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm584301770_fill_path",
    d: "M5.31013,13l-1.92,-3.336h-1.044v3.336h-1.368v-8.34h2.88001c0.64,0 1.18,0.112 1.62,0.336c0.448,0.224 0.78,0.524 0.996,0.9c0.224,0.376 0.336,0.796 0.336,1.26c0,0.544 -0.16,1.04 -0.48,1.488c-0.312,0.44 -0.796,0.74 -1.452,0.9l2.064,3.456zM2.34613,8.572h1.512c0.512,0 0.896,-0.128 1.152,-0.384c0.264,-0.256 0.396,-0.6 0.396,-1.032c0,-0.432 -0.128,-0.768 -0.384,-1.008c-0.256,-0.248 -0.644,-0.372 -1.164,-0.372h-1.512zM14.6202,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.05204c0.04,0.528 0.236,0.952 0.58804,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.70404,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.50404,-0.28 1.08004,-0.42 1.72804,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM13.1922,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.33604,0.296 -0.53604,0.7 -0.60004,1.212zM17.3344,7.36c0.232,-0.304 0.548,-0.56 0.948,-0.768c0.4,-0.208 0.852,-0.312 1.356,-0.312c0.576,0 1.1,0.144 1.572,0.432c0.48,0.28 0.856,0.676 1.128,1.188c0.272,0.512 0.408,1.1 0.408,1.764c0,0.664 -0.136,1.26 -0.408,1.788c-0.272,0.52 -0.648,0.928 -1.128,1.224c-0.472,0.288 -0.996,0.432 -1.572,0.432c-0.504,0 -0.952,-0.1 -1.344,-0.3c-0.392,-0.208 -0.712,-0.464 -0.96,-0.768v4.104h-1.368v-9.756h1.368zM21.3544,9.664c0,-0.456 -0.096,-0.848 -0.288,-1.176c-0.184,-0.336 -0.432,-0.588 -0.744,-0.756c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.344,0 -0.672,0.088 -0.984,0.264c-0.304,0.176 -0.552,0.432 -0.744,0.768c-0.184,0.336 -0.276,0.732 -0.276,1.188c0,0.456 0.092,0.856 0.276,1.2c0.192,0.336 0.44,0.592 0.744,0.768c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.312,-0.184 0.56,-0.448 0.744,-0.792c0.192,-0.344 0.288,-0.744 0.288,-1.2zM26.9672,13.108c-0.624,0 -1.188,-0.14 -1.692,-0.42c-0.504,-0.288 -0.9,-0.688 -1.188,-1.2c-0.288,-0.52 -0.432,-1.12 -0.432,-1.8c0,-0.672 0.148,-1.268 0.444,-1.788c0.296,-0.52 0.7,-0.92 1.212,-1.2c0.512,-0.28 1.084,-0.42 1.716,-0.42c0.632,0 1.204,0.14 1.716,0.42c0.512,0.28 0.916,0.68 1.212,1.2c0.296,0.52 0.444,1.116 0.444,1.788c0,0.672 -0.152,1.268 -0.456,1.788c-0.304,0.52 -0.72,0.924 -1.248,1.212c-0.52,0.28 -1.096,0.42 -1.728,0.42zM26.9672,11.92c0.352,0 0.68,-0.084 0.984,-0.252c0.312,-0.168 0.564,-0.42 0.756,-0.756c0.192,-0.336 0.288,-0.744 0.288,-1.224c0,-0.48 -0.092,-0.884 -0.276,-1.212c-0.184,-0.336 -0.428,-0.588 -0.732,-0.756c-0.304,-0.168 -0.632,-0.252 -0.984,-0.252c-0.352,0 -0.68,0.084 -0.984,0.252c-0.296,0.168 -0.532,0.42 -0.708,0.756c-0.176,0.328 -0.264,0.732 -0.264,1.212c0,0.712 0.18,1.264 0.54,1.656c0.368,0.384 0.828,0.576 1.38,0.576zM33.1196,7.348c0.2,-0.336 0.464,-0.596 0.792,-0.78c0.336,-0.192 0.732,-0.288 1.188,-0.288v1.416h-0.348c-0.536,0 -0.944,0.136 -1.224,0.408c-0.272,0.272 -0.408,0.744 -0.408,1.416v3.48h-1.368v-6.612h1.368zM37.953,7.504v3.66c0,0.248 0.056,0.428 0.168,0.54c0.12,0.104 0.32,0.156 0.6,0.156h0.84v1.14h-1.08c-0.616,0 -1.088,-0.144 -1.416,-0.432c-0.328,-0.288 -0.492,-0.756 -0.492,-1.404v-3.66h-0.78v-1.116h0.78v-1.644h1.38v1.644h1.608v1.116z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm950250214_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,283.207,83.7698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm950250214",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm950250214_fill_path",
    d: "M12.7016,0h41.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-41.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnm950250214_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm950250214_stroke_path",
    d: "M12.7016,0h41.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-41.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnm950250214_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm950250214_stroke_path",
    d: "M12.7016,0h41.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-41.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnm950250214_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -67.8,
    y: -26.0032,
    width: 203.39999999999998,
    height: 78.0096,
    fill: "url(#m6g5hnm950250214ps0)",
    mask: "url(#m6g5hnm950250214_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm922664908_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.5016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm922664908",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnm922664908_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm922664908_fill_path",
    d: "M0.01,0h14.38c0.00552,0 0.01,0.00448 0.01,0.01v14.38c0,0.00552 -0.00448,0.01 -0.01,0.01h-14.38c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-14.38c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnm922664908_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmm50127995_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.4,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmm50127995",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmm50127995_stroke_path",
    d: "M3.6,8.4h3.6h1.2c0.66274,0 1.2,-0.53726 1.2,-1.2v-3.95147c0,-0.15913 -0.06321,-0.31174 -0.17574,-0.42426l-2.64853,-2.64853c-0.11252,-0.11252 -0.26513,-0.17574 -0.42426,-0.17574h-2.75147c-0.66274,0 -1.2,0.53726 -1.2,1.2v1.2v4.8c0,0.66274 0.53726,1.2 1.2,1.2z M2.4,2.4h-2.4v7.2c0,0.66274 0.53726,1.2 1.2,1.2h6v-2.4",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmm50127995_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(1,-2.4492935982947064e-16,2.4492935982947064e-16,1,2.4,2.4)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,7.2,8.399999999999999)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -13.200000000000001,
    width: 36,
    height: 39.6,
    fill: "url(#m6g5hnmm50127995ps0)",
    mask: "url(#m6g5hnmm50127995_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm993259047_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,34.8,5.7016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnm993259047",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnm993259047_fill_path",
    d: "M5.64255,5.3728c0,0.3584 -0.0864,0.6944 -0.2592,1.008c-0.1664,0.3136 -0.432,0.5664 -0.7968,0.7584c-0.3584,0.192 -0.8128,0.288 -1.3632,0.288h-1.1232v2.5728h-1.344v-6.7008h2.4672c0.5184,0 0.96,0.0896 1.3248,0.2688c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3136 0.2784,0.6688 0.2784,1.0656zM3.16575,6.3424c0.3712,0 0.6464,-0.0832 0.8256,-0.2496c0.1792,-0.1728 0.2688,-0.4128 0.2688,-0.72c0,-0.6528 -0.3648,-0.9792 -1.0944,-0.9792h-1.0656v1.9488zM8.93918,3.2992c0.704,0 1.32162,0.1376 1.85282,0.4128c0.5376,0.2752 0.9504,0.6688 1.2384,1.1808c0.2944,0.5056 0.4416,1.0944 0.4416,1.7664c0,0.672 -0.1472,1.2608 -0.4416,1.7664c-0.288,0.4992 -0.7008,0.8864 -1.2384,1.1616c-0.5312,0.2752 -1.14882,0.4128 -1.85282,0.4128h-2.3424v-6.7008zM8.89118,8.8576c0.704,0 1.24802,-0.192 1.63202,-0.576c0.384,-0.384 0.576,-0.9248 0.576,-1.6224c0,-0.6976 -0.192,-1.2416 -0.576,-1.632c-0.384,-0.3968 -0.92802,-0.5952 -1.63202,-0.5952h-0.9504v4.4256zM17.6156,3.2992v1.0848h-2.7936v1.7184h2.1408v1.0656h-2.1408v2.832h-1.344v-6.7008z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmb26442223_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,284.207,140.0196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmb26442223",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmb26442223_fill_path",
    d: "M12.7016,0h39.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-39.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnmb26442223_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmb26442223_stroke_path",
    d: "M12.7016,0h39.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-39.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnmb26442223_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmb26442223_stroke_path",
    d: "M12.7016,0h39.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-39.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmb26442223_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -65.8,
    y: -26.0032,
    width: 197.39999999999998,
    height: 78.0096,
    fill: "url(#m6g5hnmb26442223ps0)",
    mask: "url(#m6g5hnmb26442223_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmb97752843_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.5016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmb97752843",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnmb97752843_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmb97752843_fill_path",
    d: "M0.01,0h14.38c0.00552,0 0.01,0.00448 0.01,0.01v14.38c0,0.00552 -0.00448,0.01 -0.01,0.01h-14.38c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-14.38c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnmb97752843_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmn94499361_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.1,7.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmn94499361",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmn94499361_stroke_path",
    d: "M2.1,0v5.4zM2.1,5.4l2.1,-2.1zM2.1,5.4l-2.1,-2.1",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmn94499361_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(0.7071067811865476,0.7071067811865475,-0.7071067811865475,0.7071067811865476,2.1,5.4)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-0.7071067811865475,-0.7071067811865476,0.7071067811865476,-0.7071067811865475,0,3.3000000000000003)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6.6,
    y: -7.800000000000001,
    width: 19.799999999999997,
    height: 23.400000000000002,
    fill: "url(#m6g5hnmn94499361ps0)",
    mask: "url(#m6g5hnmn94499361_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmo66842784_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.6,1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmo66842784",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmo66842784_stroke_path",
    d: "M11.4,9.36438c0.89622,-0.35112 1.8,-1.15104 1.8,-2.76438c0,-2.4 -1.99998,-3 -3,-3c0,-1.2 0,-3.6 -3.6,-3.6c-3.6,0 -3.6,2.4 -3.6,3.6c-1,0 -3,0.6 -3,3c0,1.61334 0.90377,2.41326 1.8,2.76438",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmo66842784_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-0.931092791159875,0.3647824204236184,-0.3647824204236184,-0.931092791159875,11.4,9.36438)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(0.9310941735793159,0.3647788918326426,-0.3647788918326426,0.9310941735793159,1.8000000000000014,9.36438)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -15.6,
    y: -11.7644,
    width: 46.8,
    height: 35.2932,
    fill: "url(#m6g5hnmo66842784ps0)",
    mask: "url(#m6g5hnmo66842784_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmb59869100_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,34.8,5.7016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmb59869100",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmb59869100_fill_path",
    d: "M5.07901,8.7232h-2.6688l-0.4416,1.2768h-1.4112l2.4096,-6.7104h1.5648l2.4096,6.7104h-1.4208zM4.71421,7.648l-0.9696,-2.8032l-0.9696,2.8032zM12.7285,5.3728c0,0.3584 -0.0864,0.6944 -0.2592,1.008c-0.1664,0.3136 -0.432,0.5664 -0.7968,0.7584c-0.3584,0.192 -0.8128,0.288 -1.3632,0.288h-1.12321v2.5728h-1.344v-6.7008h2.46721c0.5184,0 0.96,0.0896 1.3248,0.2688c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3136 0.2784,0.6688 0.2784,1.0656zM10.2517,6.3424c0.3712,0 0.6464,-0.0832 0.8256,-0.2496c0.1792,-0.1728 0.2688,-0.4128 0.2688,-0.72c0,-0.6528 -0.3648,-0.9792 -1.0944,-0.9792h-1.06561v1.9488zM15.0267,3.2992v6.7008h-1.344v-6.7008z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmc95328708_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,283.4072,198.0847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmc95328708",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmc95328708_fill_path",
    d: "M12.7016,0h40.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-40.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnmc95328708_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmc95328708_stroke_path",
    d: "M12.7016,0h40.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-40.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnmc95328708_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmc95328708_stroke_path",
    d: "M12.7016,0h40.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-40.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmc95328708_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -66.8,
    y: -26.0032,
    width: 200.39999999999998,
    height: 78.0096,
    fill: "url(#m6g5hnmc95328708ps0)",
    mask: "url(#m6g5hnmc95328708_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmd15125408_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.5016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmd15125408",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnmd15125408_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmd15125408_fill_path",
    d: "M0.01,0h14.38c0.00552,0 0.01,0.00448 0.01,0.01v14.38c0,0.00552 -0.00448,0.01 -0.01,0.01h-14.38c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-14.38c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnmd15125408_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmp40294812_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmp40294812",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnmp40294812_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmp40294812_stroke_path",
    d: "M-1.2,-1.2 H9.6 V12 H-1.2 Z M1.2,10.8h6c0.66274,0 1.2,-0.53726 1.2,-1.2v-5.75147c0,-0.15913 -0.06321,-0.31174 -0.17574,-0.42426l-3.24853,-3.24853c-0.11252,-0.11252 -0.26513,-0.17574 -0.42426,-0.17574h-3.35147c-0.66274,0 -1.2,0.53726 -1.2,1.2v8.4c0,0.66274 0.53726,1.2 1.2,1.2z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnmp40294812_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmp40294812_stroke_path",
    d: "M1.2,10.8h6c0.66274,0 1.2,-0.53726 1.2,-1.2v-5.75147c0,-0.15913 -0.06321,-0.31174 -0.17574,-0.42426l-3.24853,-3.24853c-0.11252,-0.11252 -0.26513,-0.17574 -0.42426,-0.17574h-3.35147c-0.66274,0 -1.2,0.53726 -1.2,1.2v8.4c0,0.66274 0.53726,1.2 1.2,1.2z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmp40294812_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -10.8,
    y: -13.200000000000001,
    width: 32.400000000000006,
    height: 39.6,
    fill: "url(#m6g5hnmp40294812ps0)",
    mask: "url(#m6g5hnmp40294812_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmq42728970_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.4,6.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmq42728970",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmq42728970_stroke_path",
    d: "M0,0l3.6,3.6M3.6,0l-3.6,3.6",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmq42728970_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-0.7071067811865477,-0.7071067811865475,0.7071067811865475,-0.7071067811865477,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(0.7071067811865476,0.7071067811865475,-0.7071067811865475,0.7071067811865476,3.6,3.6)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(0.7071067811865474,-0.7071067811865477,0.7071067811865477,0.7071067811865474,3.6,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-0.7071067811865475,0.7071067811865476,-0.7071067811865476,-0.7071067811865475,0,3.6)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 18,
    height: 18,
    fill: "url(#m6g5hnmq42728970ps0)",
    mask: "url(#m6g5hnmq42728970_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmd34789421_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,34.8,5.7016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmd34789421",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmd34789421_fill_path",
    d: "M4.75645,10l-1.4496,-2.256l-1.3152,2.256h-1.5168l2.112,-3.3792l-2.1408,-3.3216h1.5456l1.4496,2.2464l1.3056,-2.2464h1.5168l-2.1024,3.3696l2.1408,3.3312zM8.6689,8.9344h2.208v1.0656h-3.552v-6.7008h1.344zM14.0447,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1793,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0607,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4287,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6913,0 1.2512,0.1696 1.6801,0.5088c0.4351,0.3328 0.6751,0.8 0.7199,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1791,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1217,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7489,0.2496c0.4351,0.128 0.7903,0.256 1.0655,0.384c0.2753,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2977,0.592 0.2977,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4577,0.5536 -0.8161,0.7392c-0.3583,0.1792 -0.784,0.2688 -1.2768,0.2688z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnme69894415_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,280.707,25.7056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnme69894415",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnme69894415_fill_path",
    d: "M12.7016,0h46.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-46.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnme69894415_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnme69894415_stroke_path",
    d: "M12.7016,0h46.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-46.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnme69894415_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnme69894415_stroke_path",
    d: "M12.7016,0h46.7968c7.0149,0 12.7016,5.6867 12.7016,12.7016v0c0,7.0149 -5.6867,12.7016 -12.7016,12.7016h-46.7968c-7.0149,0 -12.7016,-5.6867 -12.7016,-12.7016v0c0,-7.0149 5.6867,-12.7016 12.7016,-12.7016z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnme69894415_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -72.8,
    y: -26.0032,
    width: 218.39999999999998,
    height: 78.0096,
    fill: "url(#m6g5hnme69894415ps0)",
    mask: "url(#m6g5hnme69894415_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmf31068090_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.5016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmf31068090",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6g5hnmf31068090_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmf31068090_fill_path",
    d: "M0.01,0h14.38c0.00552,0 0.01,0.00448 0.01,0.01v14.38c0,0.00552 -0.00448,0.01 -0.01,0.01h-14.38c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-14.38c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6g5hnmf31068090_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmr25609816_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.8,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmr25609816",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmr25609816_stroke_path",
    d: "M10.8,5.4c0,2.98234 -2.41766,5.4 -5.4,5.4c-2.98234,0 -5.4,-2.41766 -5.4,-5.4c0,-2.98234 2.41766,-5.4 5.4,-5.4c2.98234,0 5.4,2.41766 5.4,5.4z M7.2,5.4c0,2.98234 -0.80589,5.4 -1.8,5.4c-0.99411,0 -1.8,-2.41766 -1.8,-5.4c0,-2.98234 0.80589,-5.4 1.8,-5.4c0.99411,0 1.8,2.41766 1.8,5.4z M10.8,5.4h-10.8",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmr25609816_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(1,-2.4492935982947064e-16,2.4492935982947064e-16,1,10.8,5.4)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,5.4)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -13.200000000000001,
    y: -13.200000000000001,
    width: 39.6,
    height: 39.6,
    fill: "url(#m6g5hnmr25609816ps0)",
    mask: "url(#m6g5hnmr25609816_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmf88263790_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,34.8,5.7016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmf88263790",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmf88263790_fill_path",
    d: "M9.98639,3.2992l-1.872,6.7008h-1.584l-1.2576,-4.7712l-1.3152,4.7712l-1.5744,0.0096l-1.8048,-6.7104h1.44l1.1808,5.2032l1.3632,-5.2032h1.4976l1.2864,5.1744l1.1904,-5.1744zM15.808,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM14.416,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM18.133,5.4592c0.1728,-0.256 0.4096,-0.464 0.7104,-0.624c0.3072,-0.16 0.656,-0.24 1.0464,-0.24c0.4544,0 0.864,0.112 1.2288,0.336c0.3712,0.224 0.6624,0.544 0.8736,0.96c0.2176,0.4096 0.3264,0.8864 0.3264,1.4304c0,0.544 -0.1088,1.0272 -0.3264,1.4496c-0.2112,0.416 -0.5024,0.7392 -0.8736,0.9696c-0.3648,0.2304 -0.7744,0.3456 -1.2288,0.3456c-0.3968,0 -0.7456,-0.0768 -1.0464,-0.2304c-0.2944,-0.16 -0.5312,-0.3648 -0.7104,-0.6144v0.7584h-1.344v-7.104h1.344zM20.9458,7.3216c0,-0.32 -0.0672,-0.5952 -0.2016,-0.8256c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2112,-0.1216 -0.4416,-0.1824 -0.6912,-0.1824c-0.2432,0 -0.4736,0.064 -0.6912,0.192c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2368 -0.192,0.5152 -0.192,0.8352c0,0.32 0.064,0.5984 0.192,0.8352c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.1216 0.448,0.1824 0.6912,0.1824c0.2496,0 0.48,-0.064 0.6912,-0.192c0.2176,-0.128 0.3904,-0.3104 0.5184,-0.5472c0.1344,-0.2368 0.2016,-0.5184 0.2016,-0.8448z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmg10758713_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,130.2002,126.7129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6g5hnmg10758713",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6g5hnmg10758713_stroke_path",
    d: "M0,0h24",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6g5hnmg10758713_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(1,0,0,1,24,0)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -25.2,
    y: -1.2,
    width: 75.6,
    height: 3.5999999999999996,
    fill: "url(#m6g5hnmg10758713ps0)",
    mask: "url(#m6g5hnmg10758713_gradient_mask)"
  }))))))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnlw65761525_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 165.0458;0 165.0458;0 165.0458;0 165.0458;11.2754 153.7704;68.0936 96.9521;128.0003 37.0454;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341;163.4117 1.6341",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnlw65761525_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-163.4117;-163.4117;-163.4117;-163.4117;-152.1362;-95.318;-35.4113;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g8kjoe96977954_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 159.5696;0 159.5696;0 159.5696;0 159.5696;11.4069 148.1628;65.4868 94.0829;123.7534 35.8163;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799;157.9898 1.5799",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g8kjoe96977954_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-157.9898;-157.9898;-157.9898;-157.9898;-146.5829;-92.503;-34.2364;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g8kjof78249285_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 113.6447;0 113.6447;0 113.6447;0 113.6447;0 113.6447;0 113.6447;0 113.6447;49.2048 64.4399;102.0664 11.5783;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252;112.5195 1.1252",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g8kjof78249285_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-112.5195;-112.5195;-112.5195;-112.5195;-112.5195;-112.5195;-112.5195;-63.3147;-10.4531;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g8kjog57953543_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 110.2773;0 110.2773;0 110.2773;0 110.2773;0 110.2773;0 110.2773;0 110.2773;54.0031 56.2742;99.992 10.2853;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919;109.1855 1.0919",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g8kjog57953543_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-109.1855;-109.1855;-109.1855;-109.1855;-109.1855;-109.1855;-109.1855;-55.1823;-9.1934;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnlx43719869",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.32;0.37;1",
    keySplines: "0.54 0.49 0.15 1;0.54 0.49 0.47 0.56;0.5 0.35 0.47 0.56",
    additive: "replace",
    fill: "freeze"
  })), _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnly18310806",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.32;0.37;1",
    keySplines: "0.5 0.47 0.15 1;0.5 0.47 0.49 0.58;0.5 0.35 0.49 0.58",
    additive: "replace",
    fill: "freeze"
  })), _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnlz80059920",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.27;0.31;1",
    keySplines: "0.5 0.5 0.15 1;0.5 0.5 0.51 0.59;0.5 0.35 0.51 0.59",
    additive: "replace",
    fill: "freeze"
  })), _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnlz46355305",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.26;0.31;1",
    keySplines: "0.5 0.44 0.15 1;0.5 0.44 0.53 0.56;0.5 0.35 0.53 0.56",
    additive: "replace",
    fill: "freeze"
  })), _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnm950250214",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.37;0.43;1",
    keySplines: "0.55 0.49 0.15 1;0.55 0.49 0.48 0.59;0.5 0.35 0.48 0.59",
    additive: "replace",
    fill: "freeze"
  })), _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnmb26442223",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.37;0.42;1",
    keySplines: "0.52 0.54 0.15 1;0.52 0.54 0.44 0.61;0.5 0.35 0.44 0.61",
    additive: "replace",
    fill: "freeze"
  })), _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnmc95328708",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.33;0.38;1",
    keySplines: "0.51 0.49 0.15 1;0.51 0.49 0.47 0.56;0.5 0.35 0.47 0.56",
    additive: "replace",
    fill: "freeze"
  })), _animate16 || (_animate16 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnme69894415",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.32;0.36;1",
    keySplines: "0.44 0.53 0.15 1;0.44 0.53 0.42 0.5;0.5 0.35 0.42 0.5",
    additive: "replace",
    fill: "freeze"
  })), _animate17 || (_animate17 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnmg10758713_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 24.24;0 24.24;5.2248 19.0152;18.396 5.844;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24;24 0.24",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate18 || (_animate18 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6g5hnmg10758713_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingMotion);
export default __webpack_public_path__ + "static/media/reporting-motion.b1bda8f492f0f08d8f1ce9b0ece6e001.svg";
export { ForwardRef as ReactComponent };